import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import type { EventNotification } from '@indutrust/notification-model';
import { EnvironmentService } from '@indutrust/shared-env';
import { BaseApiClient } from '@indutrust/shared-model';

/**
 * API client for server-side event notifications — `/api/v1/events/`.
 *
 * Only the collection read is exposed in the Postman spec today; the
 * client extends {@link BaseApiClient} so future CRUD additions come for
 * free.
 */
@Service()
export class EventNotificationApiClient extends BaseApiClient<EventNotification> {
  protected envService = inject(EnvironmentService);
  protected http = inject(HttpClient);

  protected template: Partial<EventNotification> = {};

  get url(): string {
    return `${this.envService.getApiUrl()}/events`;
  }
}
